import axios from "axios";
import { useParams } from "react-router-dom";
import { formatDate } from "../../Date";
import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../config/axios";
import { ToastContainer, toast } from "react-toastify";
import { CustomImageModal, handleErrorToast } from "../../CustomFunctions";



const AppViewNavBar = ({ subcompany }) => {
  let { id, email } = useParams()
  const [allJobappdata, setAlljobappdata] = useState({});
  const [docData, setDocData] = useState([])
  const [ProfilePic, SetProfilePic] = useState("")
  const [buffer, setBuffering] = useState(true); //buffering logic
  const [subCompanyData, setSubCompanyData] = useState({});

  const getUserDocs = async () => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      const ress = await axios.get(`${BASE_URL}/userdata/userdocsfilter/${email}/`);
      setDocData(ress.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  const getUSerDetails = async () => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {

      const remark = await axios.get(
        `${BASE_URL}/jd/jobapplicant/${id}/${email}/`
      );
      setAlljobappdata(remark.data);

    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  const getUserProfile = async () => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      const res = await axios.get(`${BASE_URL}/userdata/userdataget/${email}/`);
      SetProfilePic(res.data.profilepic);

    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  useEffect(() => {
    getUSerDetails();
    getUserDocs();
    getUserProfile();
  }, [email]);
  const cvDocument = docData.find(document => document.document_name === 'CV');

  const getSubCompany = async (subcompanyId) => {
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/subcompany-by-id/${subcompanyId}/`
      );
      setSubCompanyData(res.data);
    } catch (err) {
      handleErrorToast(err)
    }
  };

  useEffect(() => {
    if (subcompany) {
      getSubCompany(subcompany);
    }
  }, [subcompany]);
  return (

    <>
      <div className="jdview-section1">
        <div>
          {ProfilePic ?
            (
              <CustomImageModal customStyle>
                <img
                  src={ProfilePic}
                  alt="Logo Preview"
                  className="jdview-section-profilepic"

                />
              </CustomImageModal>
            )
            :
            subCompanyData?.company_logo ? (
              <CustomImageModal customStyle>
                <img
                  src={subCompanyData?.company_logo}
                  alt={subCompanyData?.title}
                  className="jdview-section-profilepic"
                />
              </CustomImageModal>
            )
              :
              <CustomImageModal customStyle>
                <img
                  className="jdview-section-profilepic"
                  src="https://g-eng.s3.ap-south-1.amazonaws.com/template-img/%60logo.png"
                  alt="profile-pic"
                />
              </CustomImageModal>
          }
        </div>
        <div className="jdview-section1-b">
          <div className="jdview-section1-b-a">
            <div className="jdview-section1-b-heading1  font-weight500  font-size-heading">Experience</div>
            <div className="jdview-section1-b-heading2  font-weight500  font-size-heading">
              {allJobappdata.yearofExp} years
            </div>
          </div>
          <div className="jdview-section1-b-a">
            <div className="jdview-section1-b-heading1  font-weight500  font-size-heading">Applied department</div>
            <div className="jdview-section1-b-heading2  font-weight500  font-size-heading">
              {allJobappdata.department_name}
            </div>
          </div>
          <div className="jdview-section1-b-a">
            <div className="jdview-section1-b-heading1  font-weight500  font-size-heading">
              Applied designation
            </div>
            <div className="jdview-section1-b-heading2  font-weight500  font-size-heading">
              {allJobappdata.position_name}
            </div>
          </div>
        </div>
        <div>
          {docData.find(document => document.document_name === 'CV') ? (
            <>
              <a href={cvDocument.document_file} target="_blank">
                <button className="jdview-seaction1-b-button  font-weight500  font-size-heading">View CV</button>
              </a>
            </>
          ) : (

            ""
          )}

        </div >
      </div >
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  )
}

const PersonalInfoTab = () => {
  let { id, email } = useParams()

  const [formData, setFormData] = useState({})
  const [positionData, setPositionData] = useState({})
  const [achiveData, setAchiveData] = useState({})
  const [buffer, setBuffering] = useState(true); //buffering logic


  const getUSerDetails = async () => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      const res = await axios.get(`${BASE_URL}/userdata/userdataget/${email}/`);

      const position = await axios.get(`${BASE_URL}/userdata/positiondata/${email}/`);

      setFormData(res.data);
      setPositionData(position.data);

    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  useEffect(() => {
    getUSerDetails();
  }, [email]);

  return (


    <>
      <div className="jdview-section2-a">
        <div className="jdview-section2-b">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 4C13.0609 4 14.0783 4.42143 14.8284 5.17157C15.5786 5.92172 16 6.93913 16 8C16 9.06087 15.5786 10.0783 14.8284 10.8284C14.0783 11.5786 13.0609 12 12 12C10.9391 12 9.92172 11.5786 9.17157 10.8284C8.42143 10.0783 8 9.06087 8 8C8 6.93913 8.42143 5.92172 9.17157 5.17157C9.92172 4.42143 10.9391 4 12 4ZM12 14C16.42 14 20 15.79 20 18V20H4V18C4 15.79 7.58 14 12 14Z"
              fill="#2576BC"
            />
          </svg>
        </div>
        <div className="jdview-section2-c font-weight600  font-size-heading">Personal Information</div>
      </div>

      <div className="jdview-section2-d">
        <div className="section-d2a  width-30vw">
          <div className="personal-info font-weight400 font-size-text ">
            <table>
              <tr>
                <th className="personal-0   font-weight300  font-size-heading">Name</th>
                <td className="personal-info-1 font-weight400  font-size-subheading  ">{formData.name}</td>
              </tr>
              <tr>
                <th className="personal-0   font-weight300  font-size-heading">Data of Birth</th>
                <td className="personal-info-1 font-weight400  font-size-subheading  ">{formData.dob}</td>
              </tr>
              <tr>
                <th className="personal-0   font-weight300  font-size-heading">Email</th>
                <td className="personal-info-1 font-weight400  font-size-subheading  ">{formData.email}</td>
              </tr>
              <tr>
                <th className="personal-0   font-weight300  font-size-heading">Father's Name</th>
                <td className="personal-info-1 font-weight400  font-size-subheading  ">{formData.father_name}</td>
              </tr>
              <tr>
                <th className="personal-0   font-weight300  font-size-heading">Phone</th>
                <td className="personal-info-1 font-weight400  font-size-subheading  ">{formData.mobile}</td>
              </tr>
              <tr>
                <th className="personal-0   font-weight300  font-size-heading">Gender</th>
                <td className="personal-info-1 font-weight400  font-size-subheading  ">{formData.gender}</td>
              </tr>
              <tr>
                <th className="personal-0   font-weight300  font-size-heading">Pan Number</th>
                <td className="personal-info-1 font-weight400  font-size-subheading  ">{formData.pan}</td>
              </tr>
              <tr>
                <th className="personal-0   font-weight300  font-size-heading">Adhar Number</th>
                <td className="personal-info-1 font-weight400  font-size-subheading  ">{formData.aadhaar}</td>
              </tr>

            </table>
          </div>
        </div>


        <div className="section-d2a width-30vw">
          <div className="personal-info font-weight400 font-size-text ">
            <table>
              <tr>
                <th className="personal-0   font-weight300  font-size-heading">Current CTC</th>
                <td className="personal-info-1 font-weight400  font-size-subheading  ">{positionData.currentCTC}</td>
              </tr>
              <tr>
                <th className="personal-0   font-weight300  font-size-heading">Expected CTC</th>
                <td className="personal-info-1 font-weight400  font-size-subheading  ">{positionData.expectedCTC}</td>
              </tr>
              <tr>
                <th className="personal-0   font-weight300  font-size-heading">Monthly Inhand</th>
                <td className="personal-info-1 font-weight400  font-size-subheading  ">{positionData.monthlyinhand}</td>
              </tr>
              <tr>
                <th className="personal-0   font-weight300  font-size-heading">Area of Interest</th>
                <td className="personal-info-1 font-weight400  font-size-subheading  ">{positionData.areaOfInterest}</td>
              </tr>
              <tr>
                <th className="personal-0   font-weight300  font-size-heading">Notice Period (days)</th>
                <td className="personal-info-1 font-weight400  font-size-subheading  ">{positionData.noticePeriod}</td>
              </tr>
              <tr>
                <th className="personal-0   font-weight300  font-size-heading">Year of Experience</th>
                <td className="personal-info-1 font-weight400  font-size-subheading  ">{positionData.yearofExp}</td>
              </tr>
              <tr>
                <th className="personal-0   font-weight300  font-size-heading">When available to join</th>
                <td className="personal-info-1 font-weight400  font-size-subheading  ">{positionData.availableToJoin}</td>
              </tr>

              <tr>
                <th className="personal-0   font-weight300  font-size-heading">Worked here before</th>
                <td className="personal-info-1 font-weight400  font-size-subheading  ">{(positionData.workedBefore) ? "Yes" : "No"}</td>
              </tr>
              {positionData.workedBefore &&
                <tr>
                  <th className="personal-0   font-weight300  font-size-heading">Worked before details</th>
                  <td className="personal-info-1 font-weight400  font-size-subheading  ">{(positionData.workedBeforeInfo) ? "Yes" : "No"}</td>
                </tr>}
            </table>
          </div>
        </div>
      </div>

      <div className="jdview-section2-da">
        <div className="jdview-section2-d-custom">

          <div className="section-d6 width-30vw">
            <div className="sub-note">
              <div className="note-1 font-weight200 font-size-heading">
                <p className="add-1-heading font-weight400  font-size-heading">
                  Current Address
                </p>
              </div>
              <div className="note-2   font-weight500  font-size-heading">{formData.current_address}</div>
            </div>
          </div>
          <div className="section-d6 width-30vw">
            <div className="sub-note">
              <div className="note-1 font-weight200 font-size-heading">
                <p className="add-1-heading font-weight400  font-size-heading">
                  Permanent Address
                </p>
              </div>
              <div className="note-2   font-weight500  font-size-heading">{formData.permanent_address}</div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  )
}

const EducationInfoTab = () => {
  let { id, email } = useParams()
  const [edudata, setEduData] = useState([])
  // const [workData, setWorkData] = useState([])
  const [buffer, setBuffering] = useState(true); //buffering logic


  const getUSerDetails = async () => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {

      const resedu = await axios.get(`${BASE_URL}/userdata/EmployeeEducationDetailsallget/${email}/`);
      setEduData(resedu.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  useEffect(() => {
    getUSerDetails();
  }, [email]);

  return (


    <>
      <div className="jdview-section3">
        <div className="jdview-section2-a">
          <div className="jdview-section2-b">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <g clipPath="url(#clip0_732_2882)">
                <path
                  d="M3.33 8L10 12L20 6L10 0L0 6H10V8H3.33ZM0 8V16L2 13.78V9.2L0 8ZM10 20L5 17L3 15.8V9.8L10 14L17 9.8V15.8L10 20Z"
                  fill="#2576BC"
                />
              </g>
              <defs>
                <clipPath id="clip0_732_2882">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="jdview-section2-c font-weight600  font-size-heading">Education Information</div>
        </div>
        <div className="jdview-section2-d">
          {
            edudata.length === 0 ? (
              <div className="no-documents-message">
                No Education Data available.
              </div>
            ) :
              (edudata
                .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))
                .map((e, index) => {
                  return (
                    <div className="section-d2">
                      <div className="personal-info font-weight400 font-size-text ">
                        <div classname="info-heading   font-weight500 font-size-heading">Education Details {index + 1}</div>
                        <table>
                          <tr>
                            <th className="personal-0   font-weight300  font-size-heading">College</th>
                            <td className="personal-info-1 font-weight400  font-size-subheading  ">{e.college}</td>
                          </tr>
                          <tr>
                            <th className="personal-0   font-weight300  font-size-heading">Degree Type</th>
                            <td className="personal-info-1 font-weight400  font-size-subheading  ">{e.department}</td>
                          </tr>
                          <tr>
                            <th className="personal-0   font-weight300  font-size-heading">Stream</th>
                            <td className="personal-info-1 font-weight400  font-size-subheading  ">{e.stream}</td>
                          </tr>
                          <tr>
                            <th className="personal-0   font-weight300  font-size-heading">Institution Type</th>
                            <td className="personal-info-1 font-weight400  font-size-subheading  ">{e.institution_type}</td>
                          </tr>
                          <tr>
                            <th className="personal-0   font-weight300  font-size-heading">Grade</th>
                            <td className="personal-info-1 font-weight400  font-size-subheading  ">{e.grade}</td>
                          </tr>
                          <tr>
                            <th className="personal-0   font-weight300  font-size-heading">Start Year</th>
                            <td className="personal-info-1 font-weight400  font-size-subheading  ">{formatDate(e.startDate)}</td>
                          </tr>
                          <tr>
                            <th className="personal-0   font-weight300  font-size-heading">Passing Year</th>
                            <td className="personal-info-1 font-weight400  font-size-subheading  ">{formatDate(e.endDate)}</td>
                          </tr>
                        </table>
                      </div>
                    </div>)
                })
              )
          }

        </div>
      </div>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  )
}

const WorkInfoTab = () => {
  let { id, email } = useParams()
  // const [edudata, setEduData] = useState([])
  const [workData, setWorkData] = useState([])
  const [buffer, setBuffering] = useState(true); //buffering logic

  const getUSerDetails = async () => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      const work = await axios.get(`${BASE_URL}/userdata/userworkexpallget/${email}/`);
      setWorkData(work.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  useEffect(() => {
    getUSerDetails();
  }, [email]);

  return (


    <>
      <div className="jdview-section4">
        <div className="jdview-section2-a">
          <div className="jdview-section2-b">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1 2.75C1 2.55109 1.07902 2.36032 1.21967 2.21967C1.36032 2.07902 1.55109 2 1.75 2H12.25C12.4489 2 12.6397 2.07902 12.7803 2.21967C12.921 2.36032 13 2.55109 13 2.75C13 2.94891 12.921 3.13968 12.7803 3.28033C12.6397 3.42098 12.4489 3.5 12.25 3.5H12V17.25C12 17.4489 11.921 17.6397 11.7803 17.7803C11.6397 17.921 11.4489 18 11.25 18H9.75C9.55109 18 9.36032 17.921 9.21967 17.7803C9.07902 17.6397 9 17.4489 9 17.25V14.75C9 14.5511 8.92098 14.3603 8.78033 14.2197C8.63968 14.079 8.44891 14 8.25 14H5.75C5.55109 14 5.36032 14.079 5.21967 14.2197C5.07902 14.3603 5 14.5511 5 14.75V17.25C5 17.4489 4.92098 17.6397 4.78033 17.7803C4.63968 17.921 4.44891 18 4.25 18H1.75C1.55109 18 1.36032 17.921 1.21967 17.7803C1.07902 17.6397 1 17.4489 1 17.25C1 17.0511 1.07902 16.8603 1.21967 16.7197C1.36032 16.579 1.55109 16.5 1.75 16.5H2V3.5H1.75C1.55109 3.5 1.36032 3.42098 1.21967 3.28033C1.07902 3.13968 1 2.94891 1 2.75ZM4 5.5C4 5.36739 4.05268 5.24021 4.14645 5.14645C4.24021 5.05268 4.36739 5 4.5 5H5.5C5.63261 5 5.75979 5.05268 5.85355 5.14645C5.94732 5.24021 6 5.36739 6 5.5V6.5C6 6.63261 5.94732 6.75979 5.85355 6.85355C5.75979 6.94732 5.63261 7 5.5 7H4.5C4.36739 7 4.24021 6.94732 4.14645 6.85355C4.05268 6.75979 4 6.63261 4 6.5V5.5ZM4.5 9C4.36739 9 4.24021 9.05268 4.14645 9.14645C4.05268 9.24021 4 9.36739 4 9.5V10.5C4 10.6326 4.05268 10.7598 4.14645 10.8536C4.24021 10.9473 4.36739 11 4.5 11H5.5C5.63261 11 5.75979 10.9473 5.85355 10.8536C5.94732 10.7598 6 10.6326 6 10.5V9.5C6 9.36739 5.94732 9.24021 5.85355 9.14645C5.75979 9.05268 5.63261 9 5.5 9H4.5ZM8 5.5C8 5.36739 8.05268 5.24021 8.14645 5.14645C8.24021 5.05268 8.36739 5 8.5 5H9.5C9.63261 5 9.75979 5.05268 9.85355 5.14645C9.94732 5.24021 10 5.36739 10 5.5V6.5C10 6.63261 9.94732 6.75979 9.85355 6.85355C9.75979 6.94732 9.63261 7 9.5 7H8.5C8.36739 7 8.24021 6.94732 8.14645 6.85355C8.05268 6.75979 8 6.63261 8 6.5V5.5ZM8.5 9C8.36739 9 8.24021 9.05268 8.14645 9.14645C8.05268 9.24021 8 9.36739 8 9.5V10.5C8 10.6326 8.05268 10.7598 8.14645 10.8536C8.24021 10.9473 8.36739 11 8.5 11H9.5C9.63261 11 9.75979 10.9473 9.85355 10.8536C9.94732 10.7598 10 10.6326 10 10.5V9.5C10 9.36739 9.94732 9.24021 9.85355 9.14645C9.75979 9.05268 9.63261 9 9.5 9H8.5ZM14.25 6C14.0511 6 13.8603 6.07902 13.7197 6.21967C13.579 6.36032 13.5 6.55109 13.5 6.75V17C13.5 17.2652 13.6054 17.5196 13.7929 17.7071C13.9804 17.8946 14.2348 18 14.5 18H18.25C18.4489 18 18.6397 17.921 18.7803 17.7803C18.921 17.6397 19 17.4489 19 17.25C19 17.0511 18.921 16.8603 18.7803 16.7197C18.6397 16.579 18.4489 16.5 18.25 16.5H18V7.5H18.25C18.4489 7.5 18.6397 7.42098 18.7803 7.28033C18.921 7.13968 19 6.94891 19 6.75C19 6.55109 18.921 6.36032 18.7803 6.21967C18.6397 6.07902 18.4489 6 18.25 6H14.25ZM14.75 9.5C14.75 9.36739 14.8027 9.24021 14.8964 9.14645C14.9902 9.05268 15.1174 9 15.25 9H16.25C16.3826 9 16.5098 9.05268 16.6036 9.14645C16.6973 9.24021 16.75 9.36739 16.75 9.5V10.5C16.75 10.6326 16.6973 10.7598 16.6036 10.8536C16.5098 10.9473 16.3826 11 16.25 11H15.25C15.1174 11 14.9902 10.9473 14.8964 10.8536C14.8027 10.7598 14.75 10.6326 14.75 10.5V9.5ZM15.25 13C15.1174 13 14.9902 13.0527 14.8964 13.1464C14.8027 13.2402 14.75 13.3674 14.75 13.5V14.5C14.75 14.6326 14.8027 14.7598 14.8964 14.8536C14.9902 14.9473 15.1174 15 15.25 15H16.25C16.3826 15 16.5098 14.9473 16.6036 14.8536C16.6973 14.7598 16.75 14.6326 16.75 14.5V13.5C16.75 13.3674 16.6973 13.2402 16.6036 13.1464C16.5098 13.0527 16.3826 13 16.25 13H15.25Z"
                fill="#2576BC"
              />
            </svg>
          </div>
          <div className="jdview-section2-c font-weight600  font-size-heading">Work Experience</div>
        </div>
        <div className="jdview-section2-d">
          {
            workData.length === 0 ? (
              <div className=" section-d2c no-documents-message">
                <span style={{ fontSize: 25 }}>Fresher</span>
              </div>
            ) : (workData
              .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))
              .map((a, index) => {
                return (
                  <div className="personal-info font-weight400 section-d2 font-size-text ">
                    < div classname="info-heading   font-weight500 font-size-heading" > Company {index + 1}</div>
                    <table>
                      <tr>
                        <th className="personal-0   font-weight300  font-size-heading">Company name</th>
                        <td className="personal-info-1 font-weight400  font-size-subheading  ">{a.company}</td>
                      </tr>
                      <tr>
                        <th className="personal-0   font-weight300  font-size-heading">Designation</th>
                        <td className="personal-info-1 font-weight400  font-size-subheading  ">{a.jobposition}</td>
                      </tr>
                      <tr>
                        <th className="personal-0   font-weight300  font-size-heading">Job position</th>
                        <td className="personal-info-1 font-weight400  font-size-subheading  ">{a.jobtype}</td>
                      </tr>
                      <tr>
                        <th className="personal-0   font-weight300  font-size-heading">Duration</th>
                        <td className="personal-info-1 font-weight400  font-size-subheading  ">{formatDate(a.startDate)} to <br />{formatDate(a.endDate)}</td>
                      </tr>
                      <tr>
                        <th className="personal-0   font-weight300  font-size-heading">Monthly CTC</th>
                        <td className="personal-info-1 font-weight400  font-size-subheading  ">{a.monthlyCtc}</td>
                      </tr>
                      <tr>
                        <th className="personal-0   font-weight300  font-size-heading">Monthly in hand</th>
                        <td className="personal-info-1 font-weight400  font-size-subheading  ">{a.monthlyInhand}</td>
                      </tr>
                    </table>
                  </div>
                )
              }))
          }
        </div >
      </div >
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  )
}

const DocsTab = () => {
  let { id, email } = useParams()
  // const [edudata, setEduData] = useState([])
  const [docData, setDocData] = useState([])
  const [buffer, setBuffering] = useState(true); //buffering logic

  const getUserDocs = async () => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      const ress = await axios.get(`${BASE_URL}/userdata/userdocsfilter/${email}/`);
      setDocData(ress.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  useEffect(() => {
    getUserDocs();
  }, []);


  return (


    <>
      <div className="jdview-section4">
        <div className="jdview-section2-a">
          <div className="jdview-section2-ba">
            <svg width="40" height="40" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
              {/* <rect width="56" height="56" rx="5" fill ="#2576BC" fill-opacity="0.1" /> */}
              <path d="M18.5 30H16.5C16.2348 30 15.9804 30.1054 15.7929 30.2929C15.6054 30.4804 15.5 30.7348 15.5 31V38C15.5 38.2652 15.6054 38.5196 15.7929 38.7071C15.9804 38.8946 16.2348 39 16.5 39H18.5C19.6935 39 20.8381 38.5259 21.682 37.682C22.5259 36.8381 23 35.6935 23 34.5C23 33.3065 22.5259 32.1619 21.682 31.318C20.8381 30.4741 19.6935 30 18.5 30ZM18.5 37H17.5V32H18.5C19.163 32 19.7989 32.2634 20.2678 32.7322C20.7366 33.2011 21 33.837 21 34.5C21 35.163 20.7366 35.7989 20.2678 36.2678C19.7989 36.7366 19.163 37 18.5 37ZM39.6912 36.3862C39.8828 36.5696 39.9938 36.8215 39.9996 37.0867C40.0055 37.3518 39.9058 37.6084 39.7225 37.8C39.3743 38.1748 38.9532 38.4746 38.4851 38.6809C38.0169 38.8873 37.5116 38.9959 37 39C34.7938 39 33 36.9813 33 34.5C33 32.0187 34.7938 30 37 30C37.5116 30.0041 38.0169 30.1127 38.4851 30.3191C38.9532 30.5254 39.3743 30.8252 39.7225 31.2C39.9018 31.3924 39.9982 31.6476 39.9907 31.9105C39.9831 32.1733 39.8724 32.4227 39.6824 32.6045C39.4924 32.7863 39.2384 32.8859 38.9754 32.8818C38.7125 32.8777 38.4617 32.7702 38.2775 32.5825C38.1152 32.4039 37.9182 32.2601 37.6986 32.16C37.479 32.0598 37.2413 32.0054 37 32C35.8975 32 35 33.125 35 34.5C35 35.875 35.8975 37 37 37C37.2413 36.9946 37.479 36.9402 37.6986 36.84C37.9182 36.7399 38.1152 36.5961 38.2775 36.4175C38.4608 36.2259 38.7128 36.115 38.9779 36.1091C39.243 36.1033 39.4996 36.2029 39.6912 36.3862ZM28 30C25.7937 30 24 32.0187 24 34.5C24 36.9813 25.7937 39 28 39C30.2063 39 32 36.9813 32 34.5C32 32.0187 30.2063 30 28 30ZM28 37C26.8975 37 26 35.875 26 34.5C26 33.125 26.8975 32 28 32C29.1025 32 30 33.125 30 34.5C30 35.875 29.1025 37 28 37ZM18 27C18.2652 27 18.5196 26.8946 18.7071 26.7071C18.8946 26.5196 19 26.2652 19 26V17H30V23C30 23.2652 30.1054 23.5196 30.2929 23.7071C30.4804 23.8946 30.7348 24 31 24H37V26C37 26.2652 37.1054 26.5196 37.2929 26.7071C37.4804 26.8946 37.7348 27 38 27C38.2652 27 38.5196 26.8946 38.7071 26.7071C38.8946 26.5196 39 26.2652 39 26V23C39.0001 22.8686 38.9743 22.7385 38.9241 22.6172C38.8739 22.4958 38.8003 22.3854 38.7075 22.2925L31.7075 15.2925C31.6146 15.1997 31.5042 15.1261 31.3829 15.0759C31.2615 15.0257 31.1314 14.9999 31 15H19C18.4696 15 17.9609 15.2107 17.5858 15.5858C17.2107 15.9609 17 16.4696 17 17V26C17 26.2652 17.1054 26.5196 17.2929 26.7071C17.4804 26.8946 17.7348 27 18 27ZM32 18.4138L35.5863 22H32V18.4138Z" fill="#2576BC" />
            </svg>

          </div>
          <div className="jdview-section2-c font-weight600  font-size-heading">Documents</div>
        </div>
        <div className="jdview-section2-d">

          {/* {docData.map((a, index) => { */}
          {/* return ( */}
          <div className="personal-info font-weight400 section-d2b font-size-text ">
            {docData.length === 0 ? (
              <div className="no-documents-message">
                No documents available.
              </div>
            ) : (
              <div className="document-grid2">
                {docData.map((doc, index) => (
                  (doc.document_name == null) ? "" :
                    <div className="document-item" key={index}>

                      <div className="document-name-div">
                        {/* <img
                                src={doc.document_file}
                                alt="Document Icon"
                                className="document-icon"
                              /> */}
                        <div>
                          <div className="document-name">{doc.document_name}</div>
                          <div className="document-upload-date font-size-subheading  ">
                            Doc Type <b>{doc.document_type}</b>
                          </div>
                        </div>
                      </div>

                      <div>
                        <a href={doc.document_file} target="_blank" className="document-download-button  width-5vw  width-5vw">
                          View
                        </a>
                      </div>

                    </div>

                ))}
              </div>
            )}
          </div>
          {/* ) */}
          {/* })} */}
        </div>
      </div >
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  )
}

const ApplicantAddRoundData = ({ roundNumber, id, email, allJobappdata }) => {
  const [round_confidence, setRound_confidence] = useState("Low")
  const [round_cs, setRound_cs] = useState("Low")
  const [round_sk, setround_sk] = useState("Low")
  const [buffer, setBuffering] = useState(true); //buffering logic


  const [formData, setFormData] = useState({
    [`round${roundNumber}by`]: "",
    [`round${roundNumber}_confidence`]: "",
    [`round${roundNumber}_cs`]: "",
    [`round${roundNumber}_tk`]: "",
    [`round${roundNumber}_sk`]: "",
    [`round${roundNumber}_recomendation`]: "",
    [`round${roundNumber}_prevexp`]: "",
    [`round${roundNumber}_teamwork`]: "",
    [`r${roundNumber}remark`]: ""
  });

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      `round${roundNumber}by`,
      `round${roundNumber}_tk`,
      // `round${roundNumber}_teamwork`,
      // `round${roundNumber}_prevexp`,
      `round${roundNumber}_recomendation`,
      `r${roundNumber}remark`,
    ];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };


  console.log(errors)

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  let handleSubmitt = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setBuffering(true); //buffering logic // Start Buffering 

      // if (formData[`round${roundNumber}by`] === null || allJobappdata[`round${roundNumber}`] === true) {
      //   alert("Please fill in all required fields.");
      //   return;
      // }

      if (formData[`round${roundNumber}by`] === null) {
        alert("Please fill in all required fields.");
        return;
      }

      if (allJobappdata[`round${roundNumber}`] === true) {
        alert("Details Already Filled");
        return;
      }

      const updatedFormData = {
        ...formData,
        [`round${roundNumber}`]: "true",
        [`round${roundNumber}_cs`]: round_cs,
        [`round${roundNumber}_confidence`]: round_confidence,
        [`round${roundNumber}_sk`]: round_sk,


      }
      try {
        let res = await axios.put(`${BASE_URL}/jd/jobapplicant/${allJobappdata.id}/`, updatedFormData,);
        if (res.status === 200) {
          window.location.reload();
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err)
      } finally {
        setBuffering(false); //buffering logic // End Buffering
      }
    }
  };

  return (
    <>
      {allJobappdata[`round${roundNumber}`] ? (<></>) : (<>
        <div className="jdfinal-sub-heading font-weight600  font-size-heading">Round {roundNumber}</div>
        <form className="register-form">
          <div className="form-flex-wrap">
            <div className="flex-column">
              <label htmlFor={`round${roundNumber}by`} className="form-labels  font-weight500    font-size-subheading">
                Interviewer Name<span className="required">*</span>
              </label>
              <input
                className={`form-input ${errors[`round${roundNumber}by`] ? "error" : inputState[`round${roundNumber}by`] ? "success" : ""}`}
                placeholder="Name"
                type="text"
                maxLength={150}
                id={`round${roundNumber}by`}
                name={`round${roundNumber}by`}
                value={formData[`round${roundNumber}by`]}
                onChange={handleInputChange}
              />
              {errors[`round${roundNumber}by`] && (
                <span className="error-message font-size-text ">{errors[`round${roundNumber}by`]}</span>
              )}
            </div>
            <br />
            <div className="flex-column">
              <label htmlFor={`round${roundNumber}_tk`} className="form-labels  font-weight500    font-size-subheading">
                Technical Knowledge<span className="required">*</span>
              </label>
              <input
                className={`form-input ${errors[`round${roundNumber}_tk`] ? "error" : inputState[`round${roundNumber}_tk`] ? "success" : ""}`}
                placeholder="Technical knowledge"
                type="text"
                maxLength={150}
                id={`round${roundNumber}_tk`}
                name={`round${roundNumber}_tk`}
                value={formData[`round${roundNumber}_tk`]}
                onChange={handleInputChange}
              />
              {errors[`round${roundNumber}_tk`] && (
                <span className="error-message font-size-text ">{errors[`round${roundNumber}_tk`]}</span>
              )}
            </div>

            <div Comments="flex-column" style={{ width: "50vw" }}>
              <label htmlFor="round2_cs" className="form-labels  font-weight500    font-size-subheading">
                Communication Skill<span className="required">*</span>
              </label>
              <div className="form-inputt" value={round_cs}
                onChange={(e) =>
                  setRound_cs(e.target.value)}
              >
                <input
                  className="age-input"
                  type="radio"
                  checked={round_cs === "Low"}
                  name="round2_cs"
                  value="Low"
                />
                <label className="age-label   font-weight500    font-size-heading">Low</label>
                <input
                  className="age-input"
                  type="radio"
                  checked={round_cs === "Average"}
                  name="round2_cs"
                  value="Average"
                />
                <label className="age-label   font-weight500    font-size-heading">Average</label>
                <input
                  className="age-input"
                  type="radio"
                  checked={round_cs === "High"}
                  name="round2_cs"
                  value="High"
                />
                <label className="age-label   font-weight500    font-size-heading">High</label>
              </div>
            </div>

            <div className="flex-column" style={{ width: "34vw" }}>
              <label htmlFor="round2_confidence" className="form-labels  font-weight500    font-size-subheading">
                Confidence Level<span className="required">*</span>
              </label>
              <div className="form-inputt" value={round_confidence}
                onChange={(e) => {
                  setRound_confidence(e.target.value)
                }
                }
              >
                <input
                  className={`age-label   font-weight500   ${errors.round2_confidence
                    ? "error"
                    : inputState.round2_confidence
                      ? "success"
                      : ""
                    }`}
                  type="radio"
                  checked={round_confidence === "Low"}
                  name="round2_confidence"
                  value="Low"
                  onChange={handleInputChange}
                />
                <label className="age-label   font-weight500    font-size-heading">Low</label>
                <input
                  name={`age-label   font-weight500   ${errors.round2_confidence
                    ? "error"
                    : inputState.round2_confidence
                      ? "success"
                      : ""
                    }`}
                  type="radio"
                  checked={round_confidence === "Average"}
                  value="Average"
                  className="age-label   font-weight500    font-size-heading"
                />
                <label className="age-label  font-weight500    font-size-heading">Average</label>
                <input
                  name={`age-label  font-weight500   ${errors.round2_confidence
                    ? "error"
                    : inputState.round2_confidence
                      ? "success"
                      : ""
                    }`}
                  type="radio"
                  checked={round_confidence === "High"}
                  value="High"
                  className="age-label  font-weight500    font-size-heading"
                />
                <label className="age-label  font-weight500    font-size-heading">High</label>
              </div>
            </div>

            <div className="flex-column" style={{ width: "34vw", marginTop: "20px" }}>
              <label htmlFor="round2_sk" className="form-labels font-weight500    font-size-subheading">
                Software knowledge<span className="required">*</span>
              </label>
              <div className="form-inputt" value={round_sk}
                onChange={(e) =>
                  setround_sk(e.target.value)}
              >
                <input
                  className="age-input"
                  type="radio"
                  checked={round_sk === "Low"}
                  name="round2_sk"
                  value="Low"
                />
                <label className="age-label  font-weight500    font-size-heading">Low</label>
                <input
                  className="age-input"
                  type="radio"
                  checked={round_sk === "Average"}
                  name="round2_sk"
                  value="Average"
                />
                <label className="age-label  font-weight500    font-size-heading">Average</label>
                <input
                  className="age-input"
                  type="radio"
                  checked={round_sk === "High"}
                  name="round2_sk"
                  value="High"
                />
                <label className="age-label  font-weight500    font-size-heading">High</label>
              </div>
            </div>


            <div className="flex-column" style={{ marginTop: "20px" }}>
              <label htmlFor={`round${roundNumber}_prevexp`} className="jd-heading   font-weight500 font-size-subheading ">Previous experience</label>
              <input
                className={`form-input ${errors[`round${roundNumber}_prevexp`]
                  ? "error"
                  : inputState[`round${roundNumber}_prevexp`]
                    ? "success"
                    : ""
                  }`}
                placeholder="Previous Experience"
                maxLength={150}
                type="text"
                name={`round${roundNumber}_prevexp`}
                value={formData[`round${roundNumber}_prevexp`]}
                onChange={handleInputChange}
              />
              {errors[`round${roundNumber}_prevexp`] && (
                <span className="error-message font-size-text ">{errors[`round${roundNumber}_prevexp`]}</span>
              )}
            </div>

            <div className="flex-column">
              <label htmlFor={`round${roundNumber}_teamwork`} className="jd-heading   font-weight500 font-size-subheading ">Team work</label>
              <input
                className={`form-input ${errors[`round${roundNumber}_teamwork`]
                  ? "error"
                  : inputState[`round${roundNumber}_teamwork`]
                    ? "success"
                    : ""
                  }`}
                placeholder="Team work"
                maxLength={150}
                type="text"
                name={`round${roundNumber}_teamwork`}
                value={formData[`round${roundNumber}_teamwork`]}
                onChange={handleInputChange}
              />
              {errors[`round${roundNumber}_teamwork`] && (
                <span className="error-message font-size-text ">{errors[`round${roundNumber}_teamwork`]}</span>
              )}
            </div>

            <div className="flex-column">
              <label htmlFor={`round${roundNumber}_recomendation`} className="jd-heading   font-weight500 font-size-subheading ">Recommendation<span className="required">*</span></label>
              <input
                className={`form-input ${errors[`round${roundNumber}_recomendation`]
                  ? "error"
                  : inputState[`round${roundNumber}`]
                    ? "success"
                    : ""
                  }`}
                id={`round${roundNumber}_recomendation`}
                placeholder="Recomendation"
                maxLength={150}
                type="text"
                name={`round${roundNumber}_recomendation`}
                value={formData[`round${roundNumber}_recomendation`]}
                onChange={handleInputChange}
              />
              {errors[`round${roundNumber}_recomendation`] && (
                <span className="error-message font-size-text ">{errors[`round${roundNumber}_recomendation`]}</span>
              )}
            </div>
          </div>
          <div className="flex-column">
            <label htmlFor={`r${roundNumber}remark`} className="jd-heading   font-weight500 font-size-subheading ">Remarks:<span className="required">*</span></label>
            <textarea
              type="text"
              id={`r${roundNumber}remark`} // Use dynamic key
              name={`r${roundNumber}remark`} // Use dynamic key
              placeholder="Remark"
              maxLength={500}
              onChange={handleInputChange}
              value={formData[`r${roundNumber}remark`]} // Use dynamic key
              className={`form-input-textarea   font-weight400  font-size-subheading ${errors[`r${roundNumber}remark`] // Use dynamic key
                ? "error"
                : inputState[`r${roundNumber}remark`] // Use dynamic key
                  ? "success"
                  : ""
                }`}
            />
            {errors[`r${roundNumber}remark`] && ( // Use dynamic key
              <span className="error-message font-size-text ">{errors[`r${roundNumber}remark`]}</span> // Use dynamic ke
            )}
            <div className="button-models">
              <button
                onClick={handleSubmitt}
                className="model-button model-button-submit font-weight500   "
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      </>)}
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  );
};


const ApplicantDataView = ({ roundNumber, allJobappdata }) => {
  return (
    <>
      {allJobappdata[`round${roundNumber}`] ? (
        <>
          {/* add more */}
          <div className="section-d3  width-35vw">
            <div className="personal-info font-weight400 font-size-text ">
              <div classname="info-heading   font-weight500 font-size-heading">Round {roundNumber}</div>
              <table>
                <tr>
                  <th className="personal-0   font-weight300  font-size-heading">Assign To</th>
                  <td className="personal-info-1 font-weight400  font-size-subheading  ">{allJobappdata[`round${roundNumber}by`]}</td>
                </tr>
                <tr>
                  <th className="personal-0   font-weight300  font-size-heading">Communication Skill</th>
                  <td className="personal-info-1 font-weight400  font-size-subheading  ">{allJobappdata[`round${roundNumber}_cs`]}</td>
                </tr>
                <tr>
                  <th className="personal-0   font-weight300  font-size-heading">Confidence Level</th>
                  <td className="personal-info-1 font-weight400  font-size-subheading  ">{allJobappdata[`round${roundNumber}_confidence`]}</td>
                </tr>
                <tr>
                  <th className="personal-0   font-weight300  font-size-heading"> Team work</th>
                  <td className="personal-info-1 font-weight400  font-size-subheading  ">{allJobappdata[`round${roundNumber}_teamwork`]}</td>
                </tr>
                <tr></tr>
                <tr>
                  <th className="personal-0   font-weight300  font-size-heading">Technical Knowledge</th>
                  <td className="personal-info-1 font-weight400  font-size-subheading  ">{allJobappdata[`round${roundNumber}_tk`]}</td>
                </tr>
                <tr>
                  <th className="personal-0   font-weight300  font-size-heading">Software Knowledge</th>
                  <td className="personal-info-1 font-weight400  font-size-subheading  ">{allJobappdata[`round${roundNumber}_sk`]}</td>
                </tr>
                <tr>
                  <th className="personal-0   font-weight300  font-size-heading">Previous Experience</th>
                  <td className="personal-info-1 font-weight400  font-size-subheading  ">{allJobappdata[`round${roundNumber}_prevexp`]}</td>
                </tr>
                <tr>
                  <th className="personal-0   font-weight300  font-size-heading">Round Remarks</th>
                  <td className="personal-info-1 font-weight400  font-size-subheading   remark-display">{allJobappdata[`r${roundNumber}remark`]}</td>
                </tr>
                <tr>
                  <th className="personal-0   font-weight300  font-size-heading">Recommendation</th>
                  <td className="personal-info-1 font-weight400  font-size-subheading  ">{allJobappdata[`round${roundNumber}_recomendation`]}</td>
                </tr>
              </table>

            </div>
          </div>
        </>

      ) : (
        <>Interview Round {roundNumber} pending...</>
      )}

    </>
  )
}

const InterviewHeading = () => {
  return (
    <>
      <div className="jdfinal-section2-a">
        <div className="jdfinal-section2-a-a">
          <div className="jdfinal-section2-a-b">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              className="jdfinal-section2-a-c"
            >
              <path
                d="M12 2.625C6.83063 2.625 2.625 6.83063 2.625 12C2.625 17.1694 6.83063 21.375 12 21.375C17.1694 21.375 21.375 17.1694 21.375 12C21.375 6.83063 17.1694 2.625 12 2.625ZM12 6.46875C12.241 6.46875 12.4767 6.54023 12.6771 6.67415C12.8775 6.80806 13.0337 6.99841 13.126 7.2211C13.2182 7.4438 13.2424 7.68885 13.1953 7.92527C13.1483 8.16168 13.0322 8.37884 12.8618 8.54929C12.6913 8.71973 12.4742 8.83581 12.2378 8.88283C12.0014 8.92986 11.7563 8.90572 11.5336 8.81348C11.3109 8.72123 11.1206 8.56502 10.9866 8.3646C10.8527 8.16418 10.7812 7.92855 10.7812 7.6875C10.7812 7.36427 10.9097 7.05427 11.1382 6.82571C11.3668 6.59715 11.6768 6.46875 12 6.46875ZM14.25 17.0625H10.125C9.92609 17.0625 9.73532 16.9835 9.59467 16.8428C9.45402 16.7022 9.375 16.5114 9.375 16.3125C9.375 16.1136 9.45402 15.9228 9.59467 15.7822C9.73532 15.6415 9.92609 15.5625 10.125 15.5625H11.4375V11.4375H10.6875C10.4886 11.4375 10.2978 11.3585 10.1572 11.2178C10.0165 11.0772 9.9375 10.8864 9.9375 10.6875C9.9375 10.4886 10.0165 10.2978 10.1572 10.1572C10.2978 10.0165 10.4886 9.9375 10.6875 9.9375H12.1875C12.3864 9.9375 12.5772 10.0165 12.7178 10.1572C12.8585 10.2978 12.9375 10.4886 12.9375 10.6875V15.5625H14.25C14.4489 15.5625 14.6397 15.6415 14.7803 15.7822C14.921 15.9228 15 16.1136 15 16.3125C15 16.5114 14.921 16.7022 14.7803 16.8428C14.6397 16.9835 14.4489 17.0625 14.25 17.0625Z"
                fill="#EE5D50"
              />
            </svg>
          </div>
          <span className="jdfinal-section2-a-d font-weight600  font-size-heading">Interviewer Remarks</span>
        </div>
      </div>
    </>
  )
}

export { PersonalInfoTab, EducationInfoTab, WorkInfoTab, DocsTab, AppViewNavBar, ApplicantAddRoundData, ApplicantDataView, InterviewHeading };
